<template>
  <div
    class="projectOverview"
    v-loading="isLoading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeMethod="changeMethod"
    ></SiruiSearch>

    <!--内容区域-->
    <div class="main-content">
      <SiruiTable
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="loadingTable"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :columns="columnListDefault"
        :showFooter="true"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        @dblclickEvent="dblclickEvent"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="seq" title="序号" width="50" align="center"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :formatter="item.formatter"
          :field="item.field"
          :title="item.title"
        >
          <template slot-scope="scope">
            <span v-if="item.field == 'paymentMethod'">
              {{ transformPaymentMethod(scope.row[item.field]) }}
            </span>
            <span v-else-if="item.field == 'projectInitiationStatus'">
              {{ transformProjectInitiationStatus(scope.row[item.field]) }}
            </span>
            <span v-else-if="item.field == 'serviceChainRestriction'">
              {{ scope.row[item.field] == 0 ? '否' : '是' }}
            </span>
            <template v-else-if="item.field == 'oaUrl'">
              <a
                href="javascript:void(0);"
                v-if="scope.row[item.field]"
                @click="goOaLink(scope.row[item.field])"
                >查看</a
              >
            </template>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </SiruiTable>
    </div>
    <!-- 招标完结 -->
    <ProjectFinishDialog
      v-model="dialogVisible"
      :id="projectFinishId"
      :isExecuted="isExecuted"
      @refresh="searchBtnClick"
    />
  </div>
</template>

<script>
  import tableMixins from '@/common/mixins/table.js';
  import { formColumn, columnListDefault } from './projectOverview';
  import projectOverviewMixin from './projectOverviewMixin.js';
  import wumaoProjectApi from '@/api/purchaseSalesCenter/wumaoProject.js';
  import ProjectFinishDialog from './components/ProjectFinishDialog/index.vue';
  import companyApi from '@/api/masterData/company.js';
  import { getUserCompanyList } from '@/common/js/util';
  export default {
    name: 'WuMaoProjectOverview',
    mixins: [tableMixins, projectOverviewMixin],
    data() {
      return {
        query: {
          projectInitiationNo: '',
          projectInitiationCreateDateStart: '',
          projectInitiationCreateDateEnd: '',
          personNo: '',
          applyCompanyNo: '',
          applyDepartmentNo: '',
          chargePersonNo: '',
          projectNameLike: '',
          businessType: '',
          customerNo: '',
          platformtCompanyList: '',
          projectProvinceCode: '',
          projectCityCode: '',
          projectUsageQuotaWanStart: '',
          projectUsageQuotaWanEnd: '',
          projectReceivableQuotaWanStart: '',
          projectReceivableQuotaWanEnd: '',
          bidStatus: '',
          subjectMatter: '',
          projectInitiationStatus: '',
        },
        columnListDefault,
        multipleSelection: [], // 当前选中的行
        footerTotalCols: {
          amount: ['deliveryQuantity'],
          quantity: ['deliveryQuantity'],
        }, //底部合计列-字段名，数字类型金额amount，数量quantity等）判断小数点
        tableData: [],
        isLoading: false,
        loadingTable: false,
        menuButtonList: [],
        projectFinishId: null,
        dialogVisible: false,
        isExecuted: false, //选中行是否未已执行状态
        companyList1: [],
        projectStatusList: [],
        departmentList: [],
      };
    },
    computed: {
      searchColumns() {
        return formColumn(this);
      },
    },
    mounted() {
      this.getButtonList();
      this.getTableData();
      this._getCompanyApi1(this.userInfo.userInfo.tenantCode);
    },
    activated() {
      if (this.$route.query.deleteAction == 'delete') {
        this.getTableData();
      }
    },
    methods: {
      async getData() {
        this.getTableData();
      },
      // 平台公司
      async _getCompanyApi1() {
        this.companyList1 = await getUserCompanyList();
      },
      // 根据平台公司code获取全部的部门
      async _getDepartment(companyCodeList) {
        const { data } = await this.$axios.post(
          companyApi.GET_COMPANY_INFO_BY_CODE,
          companyCodeList
        );
        if (data.code == 0) {
          // departmentList
          console.log(data);
          this.departmentList = data.data.map((item) => {
            return {
              value: item.createDepartmentCode,
              label: item.concatCompanyName,
            };
          });
        } else {
          console.error('根据公司code获取部门失败');
        }
      },
      // 翻译回款方式
      transformPaymentMethod(it) {
        return this.dictListMap.payment_method.find((item) => item.value == it)?.label;
      },
      // 翻译项目状态
      transformProjectInitiationStatus(it) {
        return this.dictListMap.PROJECT_INITIATION_STATUS.find((item) => item.value == it)?.label;
      },
      // 表单中事件
      changeMethod({ val, prop }) {
        console.log(val, prop, '触发');
        const rowData = val[0];
        if (prop == 'personNo') {
          this.query = {
            ...this.query,
            personNo: rowData.personNo,
          };
        } else if (prop == 'chargePersonNo') {
          this.query = {
            ...this.query,
            chargePersonNo: rowData.personNo,
          };
        } else if (prop == 'customerNo') {
          this.query = {
            ...this.query,
            customerNo: rowData.partnerCode,
          };
        } else if (prop == 'platformtCompanyList') {
          if (val.length) {
            this._getDepartment(val);
          } else {
            this.departmentList = [];
          }
        } else if (prop == 'applyDepartmentNo') {
          this.query = {
            ...this.query,
            applyDepartmentNo: val,
          };
        }
      },
      getButtonList() {
        this.getButtons().then((e) => {
          if (e[1].label == '提交审批') {
            delete e[1];
          }
          this.menuButtonList = e;
        });
      },
      // 重置按钮
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.getTableData();
      },
      // 搜索
      searchBtnClick() {
        this.getTableData();
      },
      // 双击行
      dblclickEvent({ row }) {
        console.log(row, '双击行');
        const path = {
          path: '/projectInitiation/wuMaoProjectDetail',
          name: 'wuMaoProjectDetail',
          meta: {
            keepAlive: false,
            title: '项目立项详情',
          },
          query: {
            status: 'detail',
            id: row.id,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 点击按钮触发
      chooseClick(type) {
        console.log(type, '点击按钮');
        try {
          this[type]();
        } catch (e) {
          console.error(e, '当前方法未支持请联系开发');
        }
      },
      // 选择复选框
      handleSelectionChange(row) {
        console.log(row, '选择');
        this.multipleSelection = row;
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
      async getTableData() {
        const postData = {
          ...this.query,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
          applyDepartmentNoList: (this.userInfo.userInfo.allDepartmentList || []).map(
            (v) => v.personDepartmentCode
          ),
          // applyCompanyNo: this.userInfo.userInfo.companyCode,
          // applyDepartmentNo: this.query.applyDepartmentNo
          //   ? this.query.applyDepartmentNo
          //   : this.userInfo.userInfo.departmentCode,
          // businessGroup: this.userInfo.userInfo.businessGroup,
          // platformtCompanyList: this.query.platformtCompanyList?.length
          //   ? this.query.platformtCompanyList
          //   : [this.userInfo.userInfo.companyCode],
        };
        this.isLoading = true;
        const { data } = await this.$axios.post(wumaoProjectApi.GET_TABLE_DATA_PAGE, postData);
        this.isLoading = false;
        if (data.code == 0) {
          this.tableData = Object.freeze(data.data.records);
          this.$refs.siruiTable.setPageTotal(data.data.total);
        } else {
          this.$message.error('查询列表数据失败');
        }
      },
    },
    components: {
      ProjectFinishDialog,
    },
  };
</script>

<style lang="scss" scope></style>
